import * as Yup from 'yup';
import { t } from 'utils/i18n';
import { requiredField } from 'utils/string';

export const initialValues = {
  email: '',
};

export const validationSchema = Yup.object().shape({
  email: Yup.string().email(t('wrongEmailFormat')).required(requiredField('email')),
});
